import PanoramaIcon from '@mui/icons-material/Panorama'
const Icon = () => {
  return (
    <PanoramaIcon
      htmlColor='#E62E30'
      fontSize='large'
    />
  )
}

export default Icon
